import PropTypes from 'prop-types';
import { HotelRateDisplayPreferences, HotelRatePriceSubLabels } from '../../../../../constants';

const NightlyPriceDisplay = ({ pricingPreference }) => (
  <div
    className="text-xs font-normal mb-1 text-gray-600"
    title={`Per night ${pricingPreference === HotelRateDisplayPreferences.NightlyPrice ? 'with' : 'excluding'} tax`}
  >
    {HotelRatePriceSubLabels[pricingPreference] ??
      HotelRatePriceSubLabels[HotelRateDisplayPreferences.NightlyTotalWithoutTax]}
  </div>
);
NightlyPriceDisplay.propTypes = {
  pricingPreference: PropTypes.number.isRequired,
};
export default NightlyPriceDisplay;
